// extracted by mini-css-extract-plugin
module.exports = {"NewPublishersBlock":"NewPublisher_NewPublishersBlock__2OHke"};